<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<app-access
    [applicantId]="applicantId"
    (clickNewVehicle)="goToNewVehicle()"
></app-access>